import { createFileRoute } from "@tanstack/react-router";
import { SeoPageShell, H2 } from "@/components/SeoPageShell";

const TITLE = "Style My Wardrobe — AI Stylist App for Clothes You Own";
const DESC = "Upload clothes you already own and let Like2Fit's AI stylist app pair outfits for every occasion. Your personal AI wardrobe and outfit generator.";
const URL = "https://like2fit.com/style-my-wardrobe";

export const Route = createFileRoute("/style-my-wardrobe")({
  component: StyleMyWardrobePage,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: URL },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: "https://like2fit.com/" },
            { "@type": "ListItem", position: 2, name: "Style my wardrobe", item: URL },
          ],
        }),
      },
    ],
  }),
});

function StyleMyWardrobePage() {
  return (
    <SeoPageShell
      eyebrow="Style my wardrobe"
      h1="Your AI stylist for clothes you already own"
      intro="Take photos of the clothes in your wardrobe and Like2Fit pairs them into outfits for any occasion — work, dates, weekends, travel. It's the AI outfit generator your closet has been waiting for."
    >
      <H2>Build your digital wardrobe in minutes</H2>
      <p>Snap each item once and Like2Fit catalogues it automatically — colour, category, season, and styling tags. No manual tagging, no spreadsheets.</p>

      <H2>AI outfit generator for any occasion</H2>
      <p>Tell the AI stylist app where you're going — a brunch, a wedding, a flight — and get fully styled outfit ideas built only from pieces you actually own.</p>

      <H2>Smart gap-spotting</H2>
      <p>The AI wardrobe also flags what's missing. If a great outfit needs one extra piece you don't own, Like2Fit suggests shoppable matches at your budget so you complete the look instead of starting over.</p>

      <H2>Daily outfit suggestions</H2>
      <p>Wake up to a fresh "what to wear today" pick from your wardrobe, tuned to the weather and your saved style. Never start the day staring at a closet again.</p>
    </SeoPageShell>
  );
}
